import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest
} from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class APIInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const apiReq = req.clone({ url: `${environment.apiBaseUri}${req.url}` });
    return next.handle(apiReq);
  }
}

export const apiHttpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: APIInterceptor, multi: true },
];


// WEBPACK FOOTER //
// ./src/app/helper/core/api/api-interceptor.ts